import React from "react";
import { Container } from "reactstrap";
import Helmet from "react-helmet";

export const Feefo = ({
  className,
  tags
}) => {

  return (
    <>
      <Helmet>
        {tags ?
          <script
            type="text/javascript"
            src={`https://api.feefo.com/api/javascript/lorien?tags=${tags}`}
            async
          />
        :
          <script
            type="text/javascript"
            src="https://api.feefo.com/api/javascript/lorien"
            async
          />
        }
      </Helmet>

      <section className={`position-relative text-center ${className}`}>
        <Container className="py-4 py-md-5">
          <div
            id="feefo-service-review-carousel-widgetId"
            className="feefo-review-carousel-widget-service overflow-hidden"
          />
        </Container>
      </section>
    </>
  );
}

export default Feefo;
